import { useTranslation } from "react-i18next";
import { PERSONAL_APP_STORE_URL } from "./paths";
import { FOCUS } from "./ui";

/** Apple's logo, drawn here (no Apple artwork is hotlinked or bundled), for the App Store button. */
export const AppleIcon = ({ size = 20 }: { size?: number }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M16.4 12.6c0-2.4 2-3.5 2-3.6-1.1-1.6-2.8-1.8-3.4-1.8-1.4-.1-2.8.9-3.5.9-.7 0-1.8-.8-3-.8-1.5 0-3 .9-3.8 2.3-1.6 2.8-.4 7 1.2 9.3.8 1.1 1.7 2.4 2.9 2.3 1.2 0 1.6-.7 3-.7s1.8.7 3 .7c1.3 0 2.1-1.1 2.8-2.3.9-1.3 1.3-2.6 1.3-2.6s-2.5-1-2.5-3.7zM14.2 5.6c.6-.8 1.1-1.8 1-2.9-.9 0-2.1.6-2.7 1.4-.6.7-1.1 1.8-1 2.8 1 .1 2.1-.5 2.7-1.3z" />
  </svg>
);

/**
 * The Photohawk app on the App Store (PERSONAL_APP_STORE_URL): a black store button with Apple's logo and "Download on
 * the App Store", in the site's language. The repo has no official Apple badge artwork, so this is a clean text
 * button in the badge's colours (swap in Apple's badge files if the owner adds them). There is no Google Play button:
 * Android is "coming soon", in words, next to it.
 */
export const AppStoreButton = ({ testId = "app-store-link", className = "" }: { testId?: string; className?: string }) => {
  const { t } = useTranslation();
  return (
    <a
      href={PERSONAL_APP_STORE_URL}
      className={`inline-flex h-12 items-center gap-2.5 whitespace-nowrap rounded-xl border border-black bg-black px-5 text-[15px] font-semibold text-white no-underline transition-opacity hover:opacity-90 ${FOCUS} ${className}`}
      data-testid={testId}
    >
      <AppleIcon />
      {t("home.band.appStore")}
    </a>
  );
};
